import { Link } from "react-router-dom";
import { Gift, ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";

export const ReferralBand = () => (
  <section data-testid="referral-band" className="bg-[#C9A66B] text-[#14110F]">
    <div className="max-w-[1440px] mx-auto px-5 sm:px-10 py-14 sm:py-16 flex flex-col lg:flex-row lg:items-center justify-between gap-8">
      <Reveal className="flex items-start gap-5">
        <Gift className="w-9 h-9 shrink-0" strokeWidth={1.1} />
        <div>
          <p className="overline text-[0.62rem]">Porta un'amica</p>
          <h2 className="mt-2 font-serif-d font-light text-3xl sm:text-5xl leading-[1.02]">Una sorpresa <em>per entrambe.</em></h2>
        </div>
      </Reveal>
      <Reveal delay={0.1}>
        <Link to="/porta-un-amica" data-testid="referral-band-cta" className="group inline-flex items-center gap-3 rounded-full bg-[#14110F] text-[#F6F2EC] px-8 py-4 text-[0.72rem] tracking-[0.2em] uppercase transition-colors duration-500 hover:bg-[#F6F2EC] hover:text-[#14110F]">
          Crea il tuo codice <ArrowUpRight className="w-4 h-4 transition-transform duration-500 group-hover:rotate-45" />
        </Link>
      </Reveal>
    </div>
  </section>
);
